




































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import AddPrize from './components/AddPrize.vue'
import { queryDrawById, addDraw, editDraw, getDrawPrizesByDrawId } from '@/api/draw'
import { baseUrl } from '@/config.json'

interface DrawForm {
  name: string;
  image: string;
  description: string;
  price: string;
  originalPrice: string;
  status: number;
  [key: string]: any;
}

@Component({
  name: 'addShop',
  components: {
    HeadLable,
    AddPrize,
    ImageUpload
  }
})
export default class extends Vue {
  private value: string = ''
  private seachKey: string = ''
  private prizeList: any[] = []
  private imageUrl: string = ''
  private actionType: string = ''
  private prizeTable: any[] = []
  private dialogVisible: boolean = false
  private checkList: any[] = []
  private ruleForm: DrawForm = {
    name: '',
    image: '',
    description: '',
    price: '',
    originalPrice: '',
    status: 1
  }

  get rules() {
    return {
      name: {
        required: true,
        validator: (rule: any, value: string, callback: Function) => {
          if (!value) {
            callback(new Error('请输入抽奖活动名称'))
          } else {
            const reg = /^([A-Za-z0-9\u4e00-\u9fa5]){2,20}$/
            if (!reg.test(value)) {
              callback(new Error('抽奖活动名称输入不符，请输入2-20个字符'))
            } else {
              callback()
            }
          }
        },
        trigger: 'blur'
      },
      image: {
        required: true,
        message: '抽奖图片不能为空'
      },
      price: {
        validator: (rule: any, value: string, callback: Function) => {
          if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
            callback(new Error('价格格式不正确，请输入数字，最多两位小数'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      },
      originalPrice: {
        validator: (rule: any, value: string, callback: Function) => {
          if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
            callback(new Error('原价格式不正确，请输入数字，最多两位小数'))
          } else {
            callback()
          }
        },
        trigger: 'blur'
      }
    }
  }

  created() {
    this.actionType = this.$route.query.id ? 'edit' : 'add'
    if (this.actionType == 'edit') {
      this.init()
    }
  }

  private async init() {
    console.log('初始化抽奖编辑，ID：', this.$route.query.id)
    
    // 直接发送请求获取抽奖数据
    queryDrawById(String(this.$route.query.id)).then(res => {
      console.log('获取抽奖详情响应：', res)
      if (res && res.data && res.data.code === 1) {
        const data = res.data.data
        console.log('抽奖详情数据：', data)
        this.handleDrawData(data)
      } else {
        this.$message.error((res.data && res.data.msg) || '获取抽奖详情失败')
      }
    }).catch(err => {
      console.error('获取抽奖详情出错：', err)
      // 显示友好的错误信息，提示用户可能的原因
      this.$message.error('请求出错了：后端数据库可能缺少必要的表(draw_goods)，请联系管理员')
      
      // 尝试返回上一页
      setTimeout(() => {
        this.$router.back()
      }, 2000)
    })
  }

  // 处理抽奖数据的方法，统一处理逻辑
  private handleDrawData(data: any) {
    // 手动设置各个字段，确保数据类型正确
    this.ruleForm.name = data.name || ''
    this.ruleForm.description = data.description || ''
    this.ruleForm.image = data.image || ''
    this.ruleForm.status = data.status != null ? Number(data.status) : 1
    // 价格转为字符串显示，保留两位小数
    this.ruleForm.price = data.price != null ? Number(data.price).toFixed(2) : '0.00'
    this.ruleForm.originalPrice = data.originalPrice != null ? Number(data.originalPrice).toFixed(2) : '0.00'
    
    // 设置图片URL
    this.imageUrl = data.image || ''
    
    // 加载抽奖关联的奖品数据
    this.loadDrawPrizes(data.id)
  }

  // 添加新方法加载抽奖关联的奖品
  private loadDrawPrizes(drawId: string | number) {
    getDrawPrizesByDrawId(String(drawId))
      .then(res => {
        if (res && res.data && res.data.code === 1) {
          this.checkList = [...res.data.data]
          this.prizeTable = [...res.data.data]
          console.log('抽奖奖品数据加载完成：', this.prizeTable)
        } else {
          this.$message.warning('奖品数据加载失败: ' + (res.data && res.data.msg))
        }
      })
      .catch(err => {
        console.error('加载抽奖奖品出错：', err)
        this.$message.error('加载抽奖奖品失败')
      })
  }

  private seachHandle() {
    this.seachKey = this.value
  }

  // 删除抽奖商品
  delPrizeHandle(index: any) {
    this.prizeTable.splice(index, 1)
    this.checkList = this.prizeTable
    // this.checkList.splice(index, 1)
  }

  // 获取添加商品数据 - 确定加菜倒序展示
  private getCheckList(value: any) {
    this.checkList = [...value].reverse()
  }

  // 添加商品
  openAddPrize(st: string) {
    this.dialogVisible = true
  }
  
  // 取消添加奖品
  handleClose(done?: any) {
    this.dialogVisible = false
    this.checkList = JSON.parse(JSON.stringify(this.prizeTable))
  }

  // 格式化价格
  private formatPrice(price: any): string {
    if (!price) return '0.00'
    const numPrice = Number(price)
    return numPrice.toFixed(2)
  }
  
  // 在添加奖品时也需要计算概率
  addTableList() {
    this.prizeTable = JSON.parse(JSON.stringify(this.checkList));
    // 确保每个奖品都有数量属性
    this.prizeTable.forEach((n: any) => {
      n.amount = n.amount || 0; // 允许数量为0
    });
    
    this.dialogVisible = false;
  }

  // 价格输入验证直接通过表单验证器实现

  // 保存
  private submitForm(formName: string, goAhead: boolean) {
    const form: any = this.$refs[formName]
    form.validate((valid: boolean) => {
      if (valid) {
        // 验证奖品概率和数量
        if (this.prizeTable && this.prizeTable.length > 0) {
          // 确保数据类型正确
          const processedTable = this.prizeTable.map(item => ({
            ...item,
            amount: parseInt(item.amount) || 0,
            probability: parseFloat(item.probability) || 0
          }));
          
          // 计算总概率
          const totalProbability = processedTable.reduce((sum, item) => sum + item.probability, 0);
          
          // 检查是否至少有一个奖品数量大于等于1
          const hasValidAmount = processedTable.some(item => item.amount >= 1);
          
          // 验证总概率和数量
          if (totalProbability !== 100) {
            this.$message.error('总概率必须等于100%');
            return;
          }
          
          if (!hasValidAmount) {
            this.$message.error('至少应有一个奖品数量不低于1');
            return;
          }
          
          // 更新处理后的值回表格
          this.prizeTable = processedTable;
        } else {
          this.$message.error('请添加至少一个抽奖奖品');
          return;
        }
        
        // 创建一个新对象，避免直接修改this.ruleForm
        const params: any = { ...this.ruleForm }
        
        // 如果是编辑模式，确保ID被正确传递
        if (this.actionType === 'edit' && this.$route.query.id) {
          params.id = this.$route.query.id
          console.log('编辑模式，设置ID：', params.id)
        }
        
        // 确保价格是数值类型
        params.price = parseFloat(params.price || '0')
        params.originalPrice = parseFloat(params.originalPrice || '0')
        
        // 添加商品列表数据
        if (this.prizeTable && this.prizeTable.length > 0) {
          params.drawPrizes = this.prizeTable.map(item => ({
            prizeId: item.prizeId || item.id,
            name: item.name,
            price: Number(item.price || 0),
            amount: parseInt(item.amount) || 0,
            probability: parseFloat(item.probability) || 0
          }))
        }
        
        console.log('提交的参数：', params)
        const request = this.actionType === 'add' ? addDraw : editDraw
        request(params)
          .then(res => {
            if (res && res.data && res.data.code === 1) {
              this.$message.success('保存成功！')
              if (goAhead) {
                this.imageUrl = ''
                form.resetFields()
                this.ruleForm = {
                  name: '',
                  image: '',
                  description: '',
                  price: '',
                  originalPrice: '',
                  status: 1
                }
                this.prizeTable = []
                this.checkList = []
              } else {
                this.$router.push('/draw')
              }
            } else {
              this.$message.error(res.data.msg || '操作失败')
            }
          })
          .catch(err => {
            this.$message.error('请求出错了：' + err.message)
          })
      }
    })
  }

  imageChange(value: any) {
    console.log('接收到的图片URL:', value)
    try {
      // 如果value是有效的URL，则使用它
      if (value && (value.startsWith('http://') || value.startsWith('https://'))) {
        this.ruleForm.image = value
        this.imageUrl = value
        console.log('已更新图片URL:', this.ruleForm.image)
      } else if (this.imageUrl && (this.imageUrl.startsWith('http://') || this.imageUrl.startsWith('https://'))) {
        // 如果上传失败但已有原始图片URL，则保留原始图片URL
        console.log('图片上传失败，保留原始图片URL:', this.imageUrl)
        // 确保ruleForm中的image与imageUrl一致
        this.ruleForm.image = this.imageUrl
      } else {
        // 如果没有有效的URL，显示错误
        console.error('无效的图片URL')
        this.$message.warning('图片上传失败，请重试')
      }
    } catch (error) {
      console.error('图片处理错误:', error)
      // 保留原始图片URL
      if (this.imageUrl && (this.imageUrl.startsWith('http://') || this.imageUrl.startsWith('https://'))) {
        console.log('图片处理错误，保留原始图片URL:', this.imageUrl)
        // 确保ruleForm中的image与imageUrl一致
        this.ruleForm.image = this.imageUrl
      }
    }
    console.log('设置后的表单图片:', this.ruleForm.image)
    console.log('设置后的图片URL:', this.imageUrl)
  }

  handleAmountChange(item: any) {
    // 将字符串转换为数字
    const amount = parseInt(item.amount) || 0;
    
    // 如果数量为0，则概率设为0
    if (amount === 0) {
      item.probability = '0';
    }
  }
}
